function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var delay = function(duration) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, duration);
    });
};
export var retryWithBackOff = function() {
    var _ref = _async_to_generator(function(fn) {
        var options, _options_backoffMultiplier, backoffMultiplier, _options_initialDelay, initialDelay, _options_retries, retries, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _options_backoffMultiplier = options.backoffMultiplier, backoffMultiplier = _options_backoffMultiplier === void 0 ? 2 : _options_backoffMultiplier, _options_initialDelay = options.initialDelay, initialDelay = _options_initialDelay === void 0 ? 500 : _options_initialDelay, _options_retries = options.retries, retries = _options_retries === void 0 ? 3 : _options_retries;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fn()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    if (retries === 0) {
                        throw error;
                    }
                    return [
                        4,
                        delay(initialDelay)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        retryWithBackOff(fn, {
                            backoffMultiplier: backoffMultiplier,
                            initialDelay: initialDelay * backoffMultiplier,
                            retries: retries - 1
                        })
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function retryWithBackOff(fn) {
        return _ref.apply(this, arguments);
    };
}();
export var conditionalRetryWithBackOff = function() {
    var _ref = _async_to_generator(function(fn, conditionFn) {
        var options, _options_backoffMultiplier, backoffMultiplier, _options_condition, condition, _options_initialDelay, initialDelay, _options_retries, retries, cnd, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    _options_backoffMultiplier = options.backoffMultiplier, backoffMultiplier = _options_backoffMultiplier === void 0 ? 2 : _options_backoffMultiplier, _options_condition = options.condition, condition = _options_condition === void 0 ? true : _options_condition, _options_initialDelay = options.initialDelay, initialDelay = _options_initialDelay === void 0 ? 500 : _options_initialDelay, _options_retries = options.retries, retries = _options_retries === void 0 ? 3 : _options_retries;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    cnd = conditionFn();
                    if (!_instanceof(cnd, Promise)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        cnd
                    ];
                case 2:
                    if (!(_state.sent() === condition)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        fn()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!(cnd === condition)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        fn()
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    error = _state.sent();
                    if (retries === 0) {
                        throw error;
                    }
                    return [
                        3,
                        9
                    ];
                case 9:
                    if (!(retries > 0)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        delay(initialDelay)
                    ];
                case 10:
                    _state.sent();
                    return [
                        2,
                        conditionalRetryWithBackOff(fn, conditionFn, {
                            backoffMultiplier: backoffMultiplier,
                            condition: condition,
                            initialDelay: initialDelay * backoffMultiplier,
                            retries: retries - 1
                        })
                    ];
                case 11:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function conditionalRetryWithBackOff(fn, conditionFn) {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=backoff.js.map